import React, { useState } from 'react';
import { Button, Dialog, Field, TextOutput } from '../../../Core';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { Table } from '../../../Layout';
import { IWorksheetComponent } from '../../Core/types';
import { IconHelp } from '../../../../Lib/Icons';
import { getNumberOfSeparations, getSeparationPath } from '../Helpers';
import { flatten } from 'ramda';
import { IDialogProps } from 'Components/Core/Dialog/types';
import { pipe } from 'Lib/Hooks/Selectors';
import { replaceAll } from 'Lib/String';

let PortionDebugViewDialog: React.FC<IWorksheetComponent & IDialogProps> = ({
  createWorksheetSelector,
  visible,
  onClose,
}) => {
  const separationsCount = useSelector(pipe(createWorksheetSelector!('', false), getNumberOfSeparations));
  const portionPaths = [
    'WholePortion',
    ...flatten(
      Array(separationsCount)
        .fill(undefined)
        .map((_, i) => [
          `${getSeparationPath(i)}.CoarsePortion`,
          `${getSeparationPath(i)}.FinePortion`,
          `${getSeparationPath(i)}.FinePortion.Subspecimen`,
        ])
    ),
  ];

  return (
    <Dialog
      title="Portion Debug View"
      width="1200px"
      visible={visible}
      onClose={onClose}
      buttons={[
        <Button key="0" onClick={onClose as any}>
          Close
        </Button>,
      ]}
    >
      <Table
        cornerHeader="Portion"
        colHeaders={[
          'State Before Prep',
          'Prep Method',
          'State After Prep',
          'Wet Mass Source',
          'Wet Mass',
          'Dry Mass Source',
          'Dry Mass',
          'Moisture Content Source',
          'Moisture Content',
          'Is Washed?',
        ]}
        rowHeaders={portionPaths.map((p) => replaceAll(p, '.', ' -> '))}
        data={portionPaths.map((p) => [
          <Field input={<TextOutput />} name={`${p}.Preparation.StateBeforePreparation`} />,
          <Field input={<TextOutput />} name={`${p}.Preparation.PreparationMethod`} />,
          <Field input={<TextOutput />} name={`${p}.Preparation.StateAfterInitialPreparation`} />,
          <Field input={<TextOutput />} name={`${p}.Masses.WetMassSource`} />,
          <Field input={<TextOutput />} name={`${p}.Masses.WetMass`} />,
          <Field input={<TextOutput />} name={`${p}.Masses.DryMassSource`} />,
          <Field input={<TextOutput />} name={`${p}.Masses.DryMass`} />,
          <Field input={<TextOutput />} name={`${p}.Masses.MoistureContentSource`} />,
          <Field input={<TextOutput />} name={`${p}.Masses.MoistureContent`} />,
          <Field input={<TextOutput />} name={`${p}.Washing.IsWashed`} />,
        ])}
      />
    </Dialog>
  );
};

PortionDebugViewDialog = withInjectedProps(PortionDebugViewDialog);

let PortionDebugViewButton: React.FC = () => {
  const [showDialog, setShowDialog] = useState(false);
  return (
    <>
      <Button subtle onClick={() => setShowDialog(true)}>
        <IconHelp /> View portion details (DEBUG only)
      </Button>
      <PortionDebugViewDialog visible={showDialog} onClose={() => setShowDialog(false)} />
    </>
  );
};
PortionDebugViewButton = withInjectedProps(PortionDebugViewButton);

export { PortionDebugViewButton };
